<template>
        <el-tabs v-model="activeName" @tab-click="handleClick" style="padding-left: 20px;" >
            <el-tab-pane label="登录记录" name="first">
                <div class="myTable">
                    <div class="searchNav">
<!--                        <span>-->
<!--                            <span class="searchNameStyle">账号 ：</span>-->
<!--                            <el-input v-model="searchInfo.account" clearable placeholder="请输入"></el-input>-->
<!--                        </span>-->
                        <span>
                            <span class="searchNameStyle">登录时间 ：</span>
                            <el-date-picker
                                    v-model="searchInfo.date"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </span>
                        <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
                    </div>
                    <div class="tableStyle">
                        <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName">
                            <el-table-column
                                    type="index"
                                    width="50">
                            </el-table-column>
                            <el-table-column label="账号" >
                                <template slot-scope="scope">
                                    {{ scope.row.userId | showAccount }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="ip" label="登录 IP"></el-table-column>
                            <el-table-column prop="createTime" label="登录时间"></el-table-column>
                            <el-table-column label="操作状态" >
                                <template slot-scope="scope">
                                    {{ scope.row.logType | showLogType }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="enabled" label="是否成功">
                                <template slot-scope="scope">
                                    {{ scope.row.succeed | showState }}
                                </template>
                            </el-table-column>
                <!-- 自定义空数据展示 -->
                <template slot="empty">
                    <div class="empty-container">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </template>
            </el-table>
                        <el-pagination style="text-align: right;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="searchInfo.pageSize"
                    :page-sizes="[10,20, 50, 100]"
                    layout="sizes, prev, pager, next ,total"
                    :total="total">
            </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="操作日志" name="second">
                <div class="myTable">
                    <div class="searchNav">
<!--                        <span>-->
<!--                            <span class="searchNameStyle">账号 ：</span>-->
<!--                            <el-input v-model="opSearchInfo.account" clearable placeholder="请输入"></el-input>-->
<!--                        </span>-->
                        <span>
                            <span class="searchNameStyle">操作时间 ：</span>
                            <el-date-picker
                                    v-model="opSearchInfo.date"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </span>
                        <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
                    </div>
                    <div class="tableStyle">
                        <el-table v-loading="opLoading" :data="opTableData" style="width: 100%;" :row-class-name="tableRowClassName">
                            <el-table-column
                                    type="index"
                                    width="50">
                            </el-table-column>
                            <el-table-column label="账号" >
                                <template slot-scope="scope">
                                    {{ scope.row.userId | showAccount }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="operationTime" label="操作时间"></el-table-column>
                            <el-table-column prop="httpMethod" label="请求类型"></el-table-column>
                            <el-table-column prop="url" label="调用的方法"></el-table-column>
                            <el-table-column prop="enabled" label="请求状态">
                                <template slot-scope="scope">
                                    {{ scope.row.succeed | showState }}
                                </template>
                            </el-table-column>
                <!-- 自定义空数据展示 -->
                <template slot="empty">
                    <div class="empty-container">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </template>
            </el-table>
                        <el-pagination style="text-align: right;"
                                       @current-change="opHandleCurrentChange"
                                       :current-page.sync="opCurrentPage"
                                       :page-size="opSearchInfo.pageSize"
                                       layout=" prev, pager, next ,total"
                                       :total="opTotal">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>




</template>

<script>
    import {axios} from "../../config/axios";
    let userMap = new Map();
    export default {
        data () {
            return {
                loginDate:'',
                total:1,
                tableData: [],
                currentPage:1,
                loading:false,
                opTotal:1,
                opTableData: [],
                opCurrentPage:1,
                opLoading:false,
                searchInfo:{
                    date:'',
                    account:'',
                    pageNumber:1,
                    pageSize:50,
                },
                opSearchInfo:{
                    date:'',
                    account:'',
                    pageNumber:1,
                    pageSize:50,
                },
                activeName: 'first',
            }
        },
        created: function () {
            let role = localStorage.getItem("logistics-userInfo");
            if (JSON.parse(role).role === "admin") {
                this.getUserList();
            }else{
                this.pageInfo();
                this.operationLogInfo();
            }
        },
        watch: {
            'searchInfo.date'(newVal,oldVal){
                if (null == newVal){
                    this.pageInfo();
                    this.operationLogInfo();
                }
            },
            'opSearchInfo.date'(newVal,oldVal){
                if (null == newVal){
                    this.pageInfo();
                    this.operationLogInfo();
                }
            },
        },
        methods: {
            pageInfo() {
                axios.get('/accountLog', {
                    params: this.searchInfo
                }).then(result => {
                    this.loading = false;
                    if (result.code !== 200) {
                        console.log(result);
                    }
                    let page = result.data;
                    this.total = page.total;
                    this.tableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.loading = false;
                });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.currentPage = 0;
                this.searchInfo.pageSize = val ;
                this.pageInfo();
            },
            operationLogInfo() {
                axios.get('/operationLog', {
                    params: this.opSearchInfo
                }).then(result => {
                    this.opLoading = false;
                    if (result.code !== 200) {
                        console.log(result);
                    }
                    let page = result.data;
                    this.opTotal = page.total;
                    this.opTableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.opLoading = false;
                });
            },
            search(){
                this.pageInfo();
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchInfo.pageNumber = val;
                this.pageInfo();
            },
            opHandleCurrentChange(val) {
                this.opccurrentPage = val;
                this.opSearchInfo.pageNumber = val;
                this.operationLogInfo();
            },
            //改为全局方法
            getUserList(){
                axios.get('/admin-user/all',{
                    params: this.searchInfo
                }).then(result => {
                    this.loading=false;
                    if (result.code !== 200){
                        console.log(result);
                    }
                    result.data.forEach(item =>{
                        userMap.set(item.id,item.account);
                    });
                    this.pageInfo();
                    this.operationLogInfo();
                })
            }
        },
        filters: {
            showState(v){
                if (v){
                    return "成功";
                } else{
                    return "失败";
                }
            },
            showLogType(val){   //1:login,2:logout,3:register
                switch(val){
                    case 1 :
                        return "登录";
                        break; //可选
                    case 2 :
                        return "退出";
                        break; //可选
                    //你可以有任意数量的case语句
                    default : //可选
                        return "注册";
                }
            },
            showAccount(val){
                let result = userMap.get(val);
                if(typeof (result) !== "undefined"){
                    return result ;
                }
                return val;
            }
        }
    }
</script>
<style lang="less" scoped>
    .addInfoStyle div{
        line-height: 4;
        .el-input{
            margin-right: 15px;
            width: 200px;
        }
    }
</style>
